var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMobile)?_c('MobileHeader',{attrs:{"headerNavItems":_vm.headerNavItems}}):_c('DesktopHeader',{attrs:{"headerNavItems":_vm.headerNavItems}})}
var staticRenderFns = []

export { render, staticRenderFns }